export default __webpack_public_path__ + "static/floor1_image5-pc-b107895e0142d82a9a3f87a2d5d066ae.png";